var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":_vm.backToAIManHome}},[(_vm.aiManFlag === '1')?_c('movable-panel',{attrs:{"position":{x: 'right', y: 'calc((100% - 150px) / 2)'},"text":""}},[_c('img',{staticClass:"ai-man-icon",attrs:{"src":_vm.aiManFlagImgUrl}})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }